import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _PaymentLinkIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C2.44772 5 2 5.44772 2 6V9H22V6C22 5.44771 21.5523 5 21 5H3ZM24 6C24 4.34315 22.6569 3 21 3H3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34315 21 3 21H9.75C10.3023 21 10.75 20.5523 10.75 20C10.75 19.4477 10.3023 19 9.75 19H3C2.44772 19 2 18.5523 2 18V11H22V13.5C22 14.0523 22.4477 14.5 23 14.5C23.5523 14.5 24 14.0523 24 13.5V6ZM10.8999 17.5208C10.8999 15.5798 12.4797 14 14.4207 14H15.1082C15.6605 14 16.1082 14.4477 16.1082 15C16.1082 15.5523 15.6605 16 15.1082 16H14.4207C13.5843 16 12.8999 16.6844 12.8999 17.5208C12.8999 18.3539 13.5855 19.0417 14.4207 19.0417H15.1082C15.6605 19.0417 16.1082 19.4894 16.1082 20.0417C16.1082 20.594 15.6605 21.0417 15.1082 21.0417H14.4207C12.4785 21.0417 10.8999 19.4561 10.8999 17.5208ZM17.854 15C17.854 14.4477 18.3017 14 18.854 14H19.5461C21.4883 14 23.0669 15.5856 23.0669 17.5208C23.0669 19.4631 21.4814 21.0417 19.5461 21.0417H18.854C18.3017 21.0417 17.854 20.594 17.854 20.0417C17.854 19.4894 18.3017 19.0417 18.854 19.0417H19.5461C20.3792 19.0417 21.0669 18.3561 21.0669 17.5208C21.0669 16.6878 20.3814 16 19.5461 16H18.854C18.3017 16 17.854 15.5523 17.854 15ZM3.5 16C3.5 15.4477 3.94772 15 4.5 15H7.5C8.05228 15 8.5 15.4477 8.5 16C8.5 16.5523 8.05228 17 7.5 17H4.5C3.94772 17 3.5 16.5523 3.5 16ZM14.6 17.5208C14.6 16.9685 15.0477 16.5208 15.6 16.5208H18.6C19.1523 16.5208 19.6 16.9685 19.6 17.5208C19.6 18.073 19.1523 18.5208 18.6 18.5208H15.6C15.0477 18.5208 14.6 18.073 14.6 17.5208Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const PaymentLinkIcon = assignWithoutSideEffects(_PaymentLinkIcon, {
  componentId: 'PaymentLinkIcon',
});

export default PaymentLinkIcon;
